import React, { Component } from 'react'
import Popup from '../../Common/Popup'
import DropdownMenu from '../../Common/DropdownMenu'
import Chip from '../../Common/Chip'
import Footer from '../../Common/Footer'
import { getContacts, fetchEmailListContacts, addContactsToEmailList } from '../Services'
import keycloak from '../../../Components/keycloak'
import PropTypes from 'prop-types'
import { getQueryStringValue } from '../../PropertySearch/Utility/Utility'

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        minWidth: '900px',
        maxWidth: '900px',
        minHeight: '450px',
        transform: 'translate(-50%, -50%)',
        padding: 'unset',
    },
    overlay: { zIndex: 9999 }
}
let timerId

class AddContacts extends Component {

    constructor(props) {
        super()
        // super(props)
        // const sfuserId = (new URLSearchParams(window.location.search)).get('userid')
        // const sfUserName = (new URLSearchParams(window.location.search)).get('username')
        const sfuserId = getQueryStringValue('userid')
        // const sfUserName = getQueryStringValue('username')

        this.state = {
            hideUl: false,
            contacts: [],
            selectedContacts: [],
            // existingContacts: [],
            // isModalOpen: this.props.isModalOpen,
            showSpinner: false,
            sfuserId: sfuserId,
            // sfUserName: sfUserName
        }
        this.child = React.createRef()
        // console.log(this.props.criteria)

    }

    findContact(ContactArr, cid) {
        for (let i = 0; i < ContactArr.length; i++) {
            if (ContactArr[i].omniViewContactId === cid) {
                return ContactArr[i]
            }
        }

        return undefined;
    }

    // isDuplicateContact(id) {
    //     // const tempObj = _.find(this.state.selectedUsers, o => o.Id === id)
    //     const rsltContact = this.findContact(this.state.selectedContacts, id)
    //     const rsltContact2 = this.findContact(this.state.existingContacts, id)

    //     return rsltContact !== undefined || rsltContact2 !== undefined
    // }

    // getUnSelectedContacts(contactsArr, cid) {
    //     let filteredContacts = [];
    //     for (let i = 0; i < contactsArr.length; i++) {
    //         if (contactsArr[i].omniViewContactId !== cid) {
    //             filteredContacts.push(contactsArr[i])
    //         }
    //     }

    //     return filteredContacts;
    // }

    onListItemClick = id => {
        let tempSelectedContacts = this.state.selectedContacts
        let selectedIds = tempSelectedContacts.map(contact => contact.omniViewContactId)
        if (!selectedIds.includes(id)) {
            tempSelectedContacts.push(this.findContact(this.state.contacts, id))
        }
        this.setState({
            hideUl: true,
            selectedContacts: tempSelectedContacts
        })
    }

    renderListItems = listItems => {
        return listItems.map(listItem =>
            <li data-testid={listItem.omniViewContactId}
                className="py-2 px-5 cursor-pointer"
                onClick={() => this.onListItemClick(listItem.omniViewContactId)}
                key={listItem.omniViewContactId}>{listItem.firstName + ' ' + listItem.lastName}
                {/* <span className="ml-2">&#10004;</span> */}
                <span className={listItem.isContactExists ? 'ml-2' : 'hide ml-2'}>&#10004;</span>
            </li>)
    }

    renderSelectedContactChips = () => {
        return this.state.selectedContacts.map(contact => <Chip onChipDelete={this.onChipDelete} key={contact.omniViewContactId} name={contact.firstName + ' ' + contact.lastName} id={contact.omniViewContactId} />)
    }

    onSearchBoxClick = () => {
        this.setState({
            hideUl: !this.state.hideUl
        })
    }

    onChipDelete = id => {
        let tempSelectedContacts = [...this.state.selectedContacts]
        // let selectedIds= tempSelectedContacts.map(contact => contact.omniViewContactId)
        // if(selectedIds.includes(id)){
        tempSelectedContacts = tempSelectedContacts.filter(contact => contact.omniViewContactId !== id)
        // } else {
        // tempSelectedContacts.push(id) 
        // }
        this.setState({
            hideUl: true,
            // selectedUsers: _.filter(this.state.selectedUsers, o => o.Id !== id)
            selectedContacts: tempSelectedContacts // .getUnSelectedContacts(this.state.selectedContacts, id)
        })
    }

    onSearchTermChange = term => {
        this.setState({
            hideUl: false
        })
        // clearTimeout(timerId)
        // timerId = setTimeout(() => {
        this.searchContact(term)
        // }, 500)
        // console.log(timerId)
    }

    searchContact = async term => {
        // console.log('term received: ', term)
        if (!term) {
            this.setState({
                contacts: []
            })

            return
        }
        const payload = {
            searchFilter: term,
            polarisEmailListId: this.props.polarisEmailListId,
        }
        this.setState({ showSpinner: true });
        const response = await getContacts(payload)
        this.setState({ showSpinner: false });
        if (response.status === 200) {
            this.setState({
                // contacts: response.data.data.data.map(theContact => {
                //     return {
                //         Id: theContact.omniViewContactId,
                //         FullName: theContact.firstName + ' ' + theContact.lastName
                //     }
                // })
                contacts: response.data.data
            })

            // const payloadNew = { criteria: this.props.criteria, searchterm: term,size: 10 };
            // const responseNew = await fetchEmailListContacts(payloadNew);
            // console.log(responseNew)
            // if (responseNew.data.data) {
            //     this.setState({
            //         // existingContacts: responseNew.data.data.map(theContact => {
            //         //     return {
            //         //         Id: theContact.omniViewContactId,
            //         //         FullName: theContact.firstName + ' ' + theContact.lastName
            //         //     }
            //         // })
            //         existingContacts: responseNew.data.data
            //     })
            // }
            // console.log(this.state.existingContacts)

        }
    }

    onAddContactClick = async () => {
        const payload = {
            // data: {
            polarisEmailListId: this.props.polarisEmailListId,
            // omniViewSalesForceId: this.state.sfuserId,
            // omniViewPardotListId: 'asdasda',
            // emailListOfContactsName: this.props.listName,
            // polarisUserId: `${keycloak.tokenParsed.given_name} ${keycloak.tokenParsed.family_name}`,
            // createdDate: new Date(),
            // modifiedDate: new Date(),
            // omniViewUserId: this.state.sfuserId,
            // criteria: JSON.stringify(this.props.criteria),
            // emailListActionType: 'Add',
            addedContacts: this.state.selectedContacts.map(cnt => cnt.omniViewContactId),
            // deletedContacts: [],
            // }
        }
        this.setState({ showSpinner: true });
        const response = await addContactsToEmailList(payload)
        this.setState({ showSpinner: false });
        if (response.status === 200) {
            let newSearchFields = this.props.searchFields
            this.state.selectedContacts.map(cnt => newSearchFields['addedContacts'].push(cnt.omniViewContactId))
            this.props.setSearchFields(newSearchFields)
            //alert('Added successfully')
            this.child.current.hideModal()
            this.props.setEmailListsSummary({ 'summary': response.data.summary })
            this.props.setRefreshEListContacts(!this.props.refreshEListContacts)
        } else {
            alert('Unable to add Contact(s).')
            this.props.setRefreshEListContacts(!this.props.refreshEListContacts)
        }
        // this.props.setAddedContacts(mappedAddedContacts)
        // this.props.addContactList(addToList)
        // this.child.current.hideModal()
    }

    render() {
        return (
            <Popup ref={this.child} headerText="Add Contacts to the list" resetModalStatus={this.props.resetModalStatus} isOpen={this.props.isModalOpen} customStyles={customStyles}>
                <br />
                <div className="px-5">
                    <DropdownMenu placeholder="Search.." onSearchTermChange={this.onSearchTermChange} onSearchBoxClick={this.onSearchBoxClick}>
                        <ul className={`menustyling ${this.state.hideUl ? 'hide' : null}`}>
                            {this.renderListItems(this.state.contacts)}
                        </ul>
                    </DropdownMenu>
                </div>
                <br />
                <div className=" flex flex-wrap">{this.renderSelectedContactChips()}</div>
                <br />
                <Footer>
                    <button disabled={this.state.selectedContacts.length === 0} data-testid="AddContact_buttonId_test" onClick={this.onAddContactClick} className="btn btn-primary block inline-block">Add Contacts</button>
                </Footer>
                {this.state.showSpinner ? <div data-testid="test-spinner" className="fadeMe items-center justify-center text-center flex h-screen">
                    <span className="loader h-6 w-6 items-center justify-center text-center absolute ml-3" ></span>
                </div> : null}
            </Popup>
        )
    }
}

AddContacts.propTypes = {
    setAddedContacts: PropTypes.any,
    listName: PropTypes.any,
    polarisEmailListId: PropTypes.any,
    isModalOpen: PropTypes.any,
    criteria: PropTypes.any,
    searchFields: PropTypes.any,
    setSearchFields: PropTypes.any,
    setEmailListsSummary: PropTypes.any,
    refreshEListContacts: PropTypes.any,
    setRefreshEListContacts: PropTypes.any,
    resetModalStatus: PropTypes.any
}

export default AddContacts
